import kebabCase from 'lodash/kebabCase';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { currencyFormatter } from 'utils/formatter';

const ItemRow = props => {
  const { title, amount } = props;
  return (
    <tr data-testid={`row-${kebabCase(title)}`}>
      <td>{title}</td>
      <td className="text-right text-unimportant">
        {currencyFormatter(amount)}
      </td>
    </tr>
  );
};

ItemRow.propTypes = {
  title: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
};

export const ReportSummaryTable = props => {
  const {
    discounts,
    gratuity,
    grossSales,
    netSales,
    refunds,
    rounding,
    tax,
    totalCollected,
  } = props;
  return (
    <table className="table table-responsive mk-table-summary">
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <ItemRow title="Gross Sales" amount={grossSales} />
        <ItemRow title="Discounts" amount={-discounts} />
        <ItemRow title="Refunds" amount={-refunds} />
        <tr className="divider" data-testid="row-net-sales">
          <td>
            <strong>Net Sales</strong>
          </td>
          <td className="text-right">
            <strong>{currencyFormatter(netSales)}</strong>
          </td>
        </tr>
        <ItemRow title="Gratuity" amount={gratuity} />
        <ItemRow title="Tax" amount={tax} />
        <ItemRow title="Rounding" amount={rounding} />
      </tbody>
      <tfoot>
        <tr className="text-total" data-testid="row-total-collected">
          <td>
            <strong>Total Collected</strong>
          </td>
          <td className="text-right">
            <strong>{currencyFormatter(totalCollected)}</strong>
          </td>
        </tr>
      </tfoot>
    </table>
  );
};

ReportSummaryTable.propTypes = {
  discounts: PropTypes.number.isRequired,
  gratuity: PropTypes.number.isRequired,
  grossSales: PropTypes.number.isRequired,
  netSales: PropTypes.number.isRequired,
  refunds: PropTypes.number.isRequired,
  rounding: PropTypes.number.isRequired,
  tax: PropTypes.number.isRequired,
  totalCollected: PropTypes.number.isRequired,
};

const mapStateToProps = state => {
  const {
    discounts,
    gratuity,
    gross_sales: grossSales,
    net_sales: netSales,
    refunds,
    rounding,
    tax,
    total_collected: totalCollected,
  } = state.reports.sales.sales;
  return {
    discounts,
    gratuity,
    grossSales,
    netSales,
    refunds,
    rounding,
    tax,
    totalCollected,
  };
};

export default connect(mapStateToProps)(ReportSummaryTable);
